export const USE_FAKE_DATA: boolean =
  (process.env.REACT_APP_USE_FAKE_DATA || '').toLowerCase() === 'true';
